import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Shield, Award, Clock, Lock, Zap, MessageSquareQuote } from 'lucide-react';
import VideoTestimonial from './VideoTestimonial';

// const stats = [
//   { value: '300', suffix: '+', label: 'Active Counselors', icon: Users },
//   { value: '1,000', suffix: '+', label: 'Patients Treated', icon: CheckCircle2 },
//   { value: '70', suffix: '%', label: 'Less Documentation Time', icon: Clock },
//   { value: '99.9', suffix: '%', label: 'Platform Uptime', icon: Shield },
// ];

const badges = [
  { icon: Shield, label: 'HIPAA Compliant', color: 'brand' },
  { icon: Lock, label: 'End-to-End Encrypted', color: 'accent' },
  { icon: Award, label: 'One Click Claim Submission', color: 'brand' },
  { icon: Zap, label: '99.9% Platform Uptime', color: 'accent' },
  { icon: Clock, label: '70% Less Documentation Time', color: 'brand' },
];

export default function SocialProof() {
  const { ref, inView } = useScrollAnimation();

  return (
    <section className="section-padding bg-white" ref={ref}>
      <div className="container-max">
        {/* Video testimonial */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 lg:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-100 rounded-full text-sm font-medium text-brand-700 mb-4">
              <MessageSquareQuote className="w-4 h-4" />
              Hear It From a Counselor
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
              A Practicing Counselor,{' '}
              <span className="gradient-text">In Her Own Words</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Dr. Dione Floyd shares her experience with Doctorite — one minute, straight from her office.
            </p>
            <div className="border-l-2 border-brand-200 pl-4">
              <p className="font-semibold text-gray-900">Dr. Dione Floyd, LPC-S</p>
              <p className="text-sm text-gray-600">AAMFT Approved Supervisor</p>
              <p className="text-sm text-gray-500">The Wellness Counseling Group — Arlington, TX</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <VideoTestimonial />
          </motion.div>
        </div>

        {/* Stats */}
        {/* <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-16">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center p-6 rounded-2xl bg-gradient-to-br from-brand-50 to-white border border-brand-100/50"
            >
              <stat.icon className="w-8 h-8 text-brand-500 mx-auto mb-3" />
              <div className="text-3xl sm:text-4xl font-extrabold text-brand-900 mb-1">
                {stat.value}
                <span className="text-accent-500">{stat.suffix}</span>
              </div>
              <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
            </motion.div>
          ))}
        </div> */}

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-wrap justify-center gap-4 sm:gap-6"
        >
          {badges.map((badge) => (
            <div
              key={badge.label}
              className="flex items-center gap-3 px-5 py-3 bg-gray-50 rounded-xl border border-gray-100"
            >
              <badge.icon className={`w-5 h-5 ${badge.color === 'brand' ? 'text-brand-500' : 'text-accent-500'}`} />
              <span className="text-sm font-semibold text-gray-700">{badge.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
